import React from 'react';
import { RootState, useSelector } from 'src/store';
import { changeEnterHTML } from 'src/utils/changeEnter';
import { getFontURL } from 'src/utils/getFontUrl';
import { trackingList } from 'src/utils/valueHTML';

const ChoiceOptionImageHTML = () => {
  const bgImage = useSelector((state: RootState) => state.imageUpload.bgImage);
  const bgColor = useSelector((state: RootState) => state.imageUpload.bgColor);

  const radius = useSelector((state: RootState) => state.imageUpload.radius);
  const text = useSelector((state: RootState) => state.editText.text);
  const fontSize = useSelector((state: RootState) => state.editText.fontSize);
  const fontWeight = useSelector(
    (state: RootState) => state.editText.fontWeight
  );
  const color = useSelector((state: RootState) => state.editText.color);
  const fontFamily = useSelector(
    (state: RootState) => state.editText.fontFamily
  );
  const textAlign = useSelector((state: RootState) => state.editText.textAlign);
  const deeplink = useSelector(
    (state: RootState) => state.imageUpload.deeplink
  );
  const btnText = useSelector((state: RootState) => state.buttons.btnText);
  const btnFontSize = useSelector(
    (state: RootState) => state.buttons.btnFontSize
  );
  const btnFontWeight = useSelector(
    (state: RootState) => state.buttons.btnFontWeight
  );
  const btnColor = useSelector((state: RootState) => state.buttons.btnColor);
  const btnBgColorR = useSelector(
    (state: RootState) => state.buttons.btnBgColorR
  );
  const btnBgColorG = useSelector(
    (state: RootState) => state.buttons.btnBgColorG
  );
  const btnBgColorB = useSelector(
    (state: RootState) => state.buttons.btnBgColorB
  );
  const btnBgColorA = useSelector(
    (state: RootState) => state.buttons.btnBgColorA
  );
  const btnFontFamily = useSelector(
    (state: RootState) => state.buttons.btnFontFamily
  );
  const btnAgain = useSelector((state: RootState) => state.buttons.btnAgain);

  const tracking = useSelector((state: RootState) => state.trackings.tracking);
  const button1 = useSelector((state: RootState) => state.trackings.button1);
  const button2 = useSelector((state: RootState) => state.trackings.button2);

  const switchImageType = useSelector(
    (state: RootState) => state.switchButton.switchImageType
  );

  const titleFontURL = getFontURL(fontFamily?.title);
  const subTitleFontURL = getFontURL(fontFamily?.sub_title);
  const topImageButtonFontURL = getFontURL(btnFontFamily?.top_image_button);
  const bottomImageButtonFontURL = getFontURL(
    btnFontFamily?.bottom_image_button
  );
  const topLeftImageButtonFontURL = getFontURL(
    btnFontFamily?.top_left_image_button
  );
  const topRightImageButtonFontURL = getFontURL(
    btnFontFamily?.top_right_image_button
  );
  const bottomLeftImageButtonFontURL = getFontURL(
    btnFontFamily?.bottom_left_image_button
  );
  const bottomRightImageButtonFontURL = getFontURL(
    btnFontFamily?.bottom_right_image_button
  );
  const buttonFontURL = getFontURL(btnFontFamily?.close_button);

  const style = `
    @font-face {
      font-family: 'title';
      src: url(${titleFontURL});
    }

    @font-face {
      font-family: 'subTitle';
      src: url(${subTitleFontURL});
    }

    @font-face {
      font-family: 'topImageButton';
      src: url(${topImageButtonFontURL});
    }

    @font-face {
      font-family: 'bottomImageButton';
      src: url(${bottomImageButtonFontURL});
    }

    @font-face {
      font-family: 'topLeftImageButton';
      src: url(${topLeftImageButtonFontURL});
    }

    @font-face {
      font-family: 'topRightImageButton';
      src: url(${topRightImageButtonFontURL});
    }

    @font-face {
      font-family: 'bottomLeftImageButton';
      src: url(${bottomLeftImageButtonFontURL});
    }

    @font-face {
      font-family: 'bottomRightImageButton';
      src: url(${bottomRightImageButtonFontURL});
    }

    @font-face {
      font-family: 'closeButton';
      src: url(${buttonFontURL});
    }

     /* reset */
    * {
      box-sizing: border-box;
      margin: 0;
      padding: 0;
      list-style: none;
      text-decoration: none;
      
    }
    html,
    body {
      height: 100%;
      overflow: hidden;
    }
    main {
      height: 100%;
      position: relative;
    }
    a {
      color: #000000;
      cursor: pointer;
    }
    button {
      background: none;
      border: none;
    }

    .root {
      width: 100%;
      height: 100%;
      position: relative;
    }

    .in-app-wrapper {
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: space-between;
      width: 100%;
      height: 100%;
      padding: 64px 32px 32px 32px;
      background: ${bgColor?.background};
    }

    .content-wrapper {
      display: flex;
      flex-direction: column;
      gap: 5px;
      width: 100%;
      height: auto;
      max-width: 390px;
    }

    .title-container {
      width: 100%;
      height: auto;
      max-height: 120px;
    }

    .main-title {
      font-size: ${fontSize?.title}rem;
      font-weight: ${fontWeight?.title};
      font-family: ${
        ['Roboto', 'Inter', 'Montserrat', 'Poppins', 'Pretendard'].includes(
          fontFamily?.title
        )
          ? fontFamily?.title
          : 'title'
      };
      line-height: 1.4;
      text-align: ${textAlign?.title};
      color: ${color?.title};
    }

    .subtitle-container {
      width: 100%;
      height: auto;
      max-height: 100px;
    }

    .subtitle {
      font-size: ${fontSize?.sub_title}rem;
      font-weight: ${fontWeight?.sub_title};
      font-family: ${
        ['Roboto', 'Inter', 'Montserrat', 'Poppins', 'Pretendard'].includes(
          fontFamily?.sub_title
        )
          ? fontFamily?.sub_title
          : 'subTitle'
      };
      line-height: 1.4;
      text-align: ${textAlign?.sub_title};
      color: ${color?.sub_title};
    }

    .image-grid {
      display: flex;
      flex-direction: column;
      align-items: center;
      max-width: 320px;
      width: 100%;
      height: auto;
      gap: 15px;
    }

    .image-large-container {
      display: flex;
      flex-direction: column;
      width: 100%;
      max-width: 320px;
      aspect-ratio: 3 / 2;
      overflow: hidden;
      box-shadow: 0 0 8px 0 rgba(0, 0, 0, 0.15);
    }

    .image-wrapper {
      width: 100%;
      height: 75%;
      background: #D9D9D9;
    }

    .image {
      width: 100%;
      height: 100%;
      object-fit: cover;
    }

    .image-title {
      text-align: center;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
      line-height: 1.4;
    }

    .top-title {
      font-size: ${btnFontSize?.top_image_button}rem;
      font-weight: ${btnFontWeight?.top_image_button};
      color: ${btnColor?.top_image_button};
      font-family: ${
        ['Roboto', 'Inter', 'Montserrat', 'Poppins', 'Pretendard'].includes(
          btnFontFamily?.top_image_button
        )
          ? btnFontFamily?.top_image_button
          : 'topImageButton'
      };
    }

    .bottom-title {
      font-size: ${btnFontSize?.bottom_image_button}rem;
      font-weight: ${btnFontWeight?.bottom_image_button};
      color: ${btnColor?.bottom_image_button};
      font-family: ${
        ['Roboto', 'Inter', 'Montserrat', 'Poppins', 'Pretendard'].includes(
          btnFontFamily?.bottom_image_button
        )
          ? btnFontFamily?.bottom_image_button
          : 'bottomImageButton'
      };
    }

    .top-left-title {
      font-size: ${btnFontSize?.top_left_image_button}rem;
      font-weight: ${btnFontWeight?.top_left_image_button};
      color: ${btnColor?.top_left_image_button};
      font-family: ${
        ['Roboto', 'Inter', 'Montserrat', 'Poppins', 'Pretendard'].includes(
          btnFontFamily?.top_left_image_button
        )
          ? btnFontFamily?.top_left_image_button
          : 'topLeftImageButton'
      };
    }

    .top-right-title {
      font-size: ${btnFontSize?.top_right_image_button}rem;
      font-weight: ${btnFontWeight?.top_right_image_button};
      color: ${btnColor?.top_right_image_button};
      font-family: ${
        ['Roboto', 'Inter', 'Montserrat', 'Poppins', 'Pretendard'].includes(
          btnFontFamily?.top_right_image_button
        )
          ? btnFontFamily?.top_right_image_button
          : 'topRightImageButton'
      };
    }

    .bottom-left-title {
      font-size: ${btnFontSize?.bottom_left_image_button}rem;
      font-weight: ${btnFontWeight?.bottom_left_image_button};
      color: ${btnColor?.bottom_left_image_button};
      font-family: ${
        ['Roboto', 'Inter', 'Montserrat', 'Poppins', 'Pretendard'].includes(
          btnFontFamily?.bottom_left_image_button
        )
          ? btnFontFamily?.bottom_left_image_button
          : 'bottomLeftImageButton'
      };
    }

    .bottom-right-title {
      font-size: ${btnFontSize?.bottom_right_image_button}rem;
      font-weight: ${btnFontWeight?.bottom_right_image_button};
      color: ${btnColor?.bottom_right_image_button};
      font-family: ${
        ['Roboto', 'Inter', 'Montserrat', 'Poppins', 'Pretendard'].includes(
          btnFontFamily?.bottom_right_image_button
        )
          ? btnFontFamily?.bottom_right_image_button
          : 'bottomRightImageButton'
      };
    }

    .image-row {
      display: flex;
      flex-direction: row;
      justify-content: space-between;
      width: 100%;
      max-width: 320px;
      height: auto;
    }

    .image-small-container {
      width: 48%;
      max-width: 150px;
      aspect-ratio: 3 / 4;
      box-shadow: 0 0 8px 0 rgba(0, 0, 0, 0.15);
      overflow: hidden;
    }

    .close-button {
      width: 100%;
      height: 60px;
      max-width: 320px;
      display: flex;
      justify-content: center;
      align-items: center;
      border-radius: ${radius?.close_button}px;
      background: rgba(${btnBgColorR?.close_button}, ${
    btnBgColorG?.close_button
  }, ${btnBgColorB?.close_button}, ${btnBgColorA?.close_button});
    }

    .close-text {
      font-size: ${btnFontSize?.close_button}rem;
      font-weight: ${btnFontWeight?.close_button};
      color: ${btnColor?.close_button};
      font-family: ${
        ['Roboto', 'Inter', 'Montserrat', 'Poppins', 'Pretendard'].includes(
          btnFontFamily?.close_button
        )
          ? btnFontFamily?.close_button
          : 'closeButton'
      };
      line-height: 1.4;
      text-align: center;
    }

    .image-large-title-container {
      width: 100%;
      height: 25%;
      background: rgba(${btnBgColorR?.top_image_button}, ${
    btnBgColorG?.top_image_button
  }, ${btnBgColorB?.top_image_button}, ${btnBgColorA?.top_image_button});
      display: flex;
      justify-content: center;
      align-items: center;
      padding: 0 10px;
    }

    .image-title-container {
      width: 100%;
      height: 25%;
      display: flex;
      justify-content: center;
      align-items: center;
      padding: 0 10px;
    }

    .image-large-title {
      text-align: center;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
      font-size: ${btnFontSize?.top_image_button}rem;
      font-weight: ${btnFontWeight?.top_image_button};
      color: ${btnColor?.top_image_button};
      line-height: 1.4;
    }

    .top {
      border-radius: ${radius?.top_image}px;
    }

    .bottom {
      border-radius: ${radius?.bottom_image}px;
    }

    .top-left {
      border-radius: ${radius?.top_left_image}px;
    }

    .top-right {
      border-radius: ${radius?.top_right_image}px;
    }

    .bottom-left {
      border-radius: ${radius?.bottom_left_image}px;
    }

    .bottom-right {
      border-radius: ${radius?.bottom_right_image}px;
    }

    .top-container {
      background: rgba(${btnBgColorR?.top_image_button}, ${
    btnBgColorG?.top_image_button
  }, ${btnBgColorB?.top_image_button}, ${btnBgColorA?.top_image_button});
    }

    .bottom-container {
      background: rgba(${btnBgColorR?.bottom_image_button}, ${
    btnBgColorG?.bottom_image_button
  }, ${btnBgColorB?.bottom_image_button}, ${btnBgColorA?.bottom_image_button});
    }

    .top-left-container {
      background: rgba(${btnBgColorR?.top_left_image_button}, ${
    btnBgColorG?.top_left_image_button
  }, ${btnBgColorB?.top_left_image_button}, ${
    btnBgColorA?.top_left_image_button
  });
    }

    .top-right-container {
      background: rgba(${btnBgColorR?.top_right_image_button}, ${
    btnBgColorG?.top_right_image_button
  }, ${btnBgColorB?.top_right_image_button}, ${
    btnBgColorA?.top_right_image_button
  });
    }

    .bottom-left-container {
      background: rgba(${btnBgColorR?.bottom_left_image_button}, ${
    btnBgColorG?.bottom_left_image_button
  }, ${btnBgColorB?.bottom_left_image_button}, ${
    btnBgColorA?.bottom_left_image_button
  });
    }

    .bottom-right-container {
      background: rgba(${btnBgColorR?.bottom_right_image_button}, ${
    btnBgColorG?.bottom_right_image_button
  }, ${btnBgColorB?.bottom_right_image_button}, ${
    btnBgColorA?.bottom_right_image_button
  });
    }

    @media screen and (max-height: 700px) {
    .in-app-wrapper {
        padding: 16px;
      }
    }
  `;

  const deeplink_list = JSON.stringify([
    deeplink?.top_image,
    deeplink?.bottom_image,
    deeplink?.top_left_image,
    deeplink?.top_right_image,
    deeplink?.bottom_left_image,
    deeplink?.bottom_right_image
  ]);

  const tracking_list = JSON.stringify([
    tracking?.top_image_button?.[0],
    tracking?.bottom_image_button?.[0],
    tracking?.top_left_image_button?.[0],
    tracking?.top_right_image_button?.[0],
    tracking?.bottom_left_image_button?.[0],
    tracking?.bottom_right_image_button?.[0],
    tracking?.close_button?.[0]
  ]);

  const tracking_button_list = trackingList(
    'CHOICE OPTION IMAGE',
    button1,
    button2
  );

  let imageWrapperHtml = '';
  if (switchImageType && switchImageType === 'double') {
    imageWrapperHtml = `
     <div class="image-large-container top">
        <div class="image-wrapper">
          <img class="image" src=${bgImage?.top_image} alt="" />
        </div>
        <div class="image-large-title-container top-container">
          <div class="image-large-title top-title">
            ${changeEnterHTML(btnText?.top_image_button)}
          </div>
        </div>
      </div>
      <div class="image-large-container bottom">
        <div class="image-wrapper">
          <img class="image" src=${bgImage?.bottom_image} alt="" />
        </div>
        <div class="image-large-title-container bottom-container">
          <div class="image-large-title bottom-title">
            ${changeEnterHTML(btnText?.bottom_image_button)}
          </div>
        </div>
      </div>
    `;
  } else {
    imageWrapperHtml = `
    <div class="image-row">
      <div class="image-small-container top-left">
        <div class="image-wrapper">
          <img
            class="image"
            src=${bgImage?.top_left_image}
            alt=""
          />
        </div>
        <div class="image-title-container top-left-container">
          <div class="image-title top-left-title">
            ${changeEnterHTML(btnText?.top_left_image_button)}
          </div>
        </div>
      </div>
      <div class="image-small-container top-right">
        <div class="image-wrapper">
          <img
            class="image"
            src=${bgImage?.top_right_image}
            alt=""
          />
        </div>
        <div class="image-title-container top-right-container">
          <div class="image-title top-right-title">
            ${changeEnterHTML(btnText?.top_right_image_button)}
          </div>
        </div>
      </div>
    </div>
    <div class="image-row">
      <div class="image-small-container bottom-left">
        <div class="image-wrapper">
          <img
            class="image"
            src=${bgImage?.bottom_left_image}
            alt=""
          />
        </div>
        <div class="image-title-container bottom-left-container">
          <div class="image-title bottom-left-title">
            ${changeEnterHTML(btnText?.bottom_left_image_button)}
          </div>
        </div>
      </div>
      <div class="image-small-container bottom-right">
        <div class="image-wrapper">
          <img
            class="image"
            src=${bgImage?.bottom_right_image}
            alt=""
          />
        </div>
        <div class="image-title-container bottom-right-container">
          <div class="image-title bottom-right-title">
            ${changeEnterHTML(btnText?.bottom_right_image_button)}
          </div>
        </div>
      </div>
    </div>
    `;
  }

  const html = `
   <div class="root">
        <div class="in-app-wrapper">
            <div class="content-wrapper">
                <div class="title-container">
                  <p class="main-title">${changeEnterHTML(text?.title)}</p>
                </div>
                <div class="subtitle-container">
                  <p class="subtitle">${changeEnterHTML(text?.sub_title)}</p>
                </div>
            </div>
            <div class="image-grid">
              ${imageWrapperHtml}
            </div>
            <div class="close-button">
              <p class="close-text">${changeEnterHTML(
                btnText?.close_button
              )}</p>
            </div>
        </div>
           <div id="deeplink" style="display:none;">
            ${deeplink_list}
        </div>
    </div>
  `;

  const js = `
  document.addEventListener("DOMContentLoaded", function(){
    const content = document.getElementById("deeplink").textContent;
    const link = content.replace(/\\n|\\t/g, "").trim();
    const deeplink = JSON.parse(link);
    const tracking = ${tracking_list};
    const button1 = ${tracking_button_list[0]};
    const button2 = ${tracking_button_list[1]};

    const topContainer = document.querySelector('.image-large-container.top');
    if (topContainer) {
      topContainer.addEventListener('click', function(){
        try {
          appboyBridge.logClick(tracking[0]);
          if(button1[0].indexOf(0) !== -1) {
            appboyBridge.logClick('0');
          }
          if(button2[0].indexOf(0) !== -1) {
            appboyBridge.logClick('1');
          }
        } catch(error) {}
        window.location = deeplink[0];
      });
    }

    const bottomContainer = document.querySelector('.image-large-container.bottom');
    if (bottomContainer) {
      bottomContainer.addEventListener('click', function(){
        try {
          appboyBridge.logClick(tracking[1]);
          if(button1[1].indexOf(0) !== -1) {
            appboyBridge.logClick('0');
          }
          if(button2[1].indexOf(0) !== -1) {
            appboyBridge.logClick('1');
          }
        } catch(error) {}
        window.location = deeplink[1];
      });
    }

    const topLeftContainer = document.querySelector('.image-small-container.top-left');
    if (topLeftContainer) {
      topLeftContainer.addEventListener('click', function(){
        try {
          appboyBridge.logClick(tracking[2]);
          if(button1[2].indexOf(0) !== -1) {
            appboyBridge.logClick('0');
          }
          if(button2[2].indexOf(0) !== -1) {
            appboyBridge.logClick('1');
          }
        } catch(error) {}
        window.location = deeplink[2];
      });
    }

    const topRightContainer = document.querySelector('.image-small-container.top-right');
    if (topRightContainer) {
      topRightContainer.addEventListener('click', function(){
        try {
          appboyBridge.logClick(tracking[3]);
          if(button1[3].indexOf(0) !== -1) {
            appboyBridge.logClick('0');
          }
          if(button2[3].indexOf(0) !== -1) {
            appboyBridge.logClick('1');
          }
        } catch(error) {}
        window.location = deeplink[3];
      });
    }

    const bottomLeftContainer = document.querySelector('.image-small-container.bottom-left');
    if (bottomLeftContainer) {
      bottomLeftContainer.addEventListener('click', function(){
        try {
          appboyBridge.logClick(tracking[4]);
          if(button1[4].indexOf(0) !== -1) {
            appboyBridge.logClick('0');
          }
          if(button2[4].indexOf(0) !== -1) {
            appboyBridge.logClick('1');
          }
        } catch(error) {}
        window.location = deeplink[4];
      });
    }

    const bottomRightContainer = document.querySelector('.image-small-container.bottom-right');
    if (bottomRightContainer) {
      bottomRightContainer.addEventListener('click', function(){
        try {
          appboyBridge.logClick(tracking[5]);
          if(button1[5].indexOf(0) !== -1) {
            appboyBridge.logClick('0');
          }
          if(button2[5].indexOf(0) !== -1) {
            appboyBridge.logClick('1');
          }
        } catch(error) {}
        window.location = deeplink[5];
      });
    }

    const closeButton = document.querySelector('.close-button');
    if (closeButton) {
      closeButton.addEventListener('click', function(){
        try {
          appboyBridge.logClick(tracking[6]);
          if(button1[6].indexOf(0) !== -1) {
            appboyBridge.logClick('0');
          }
          if(button2[6].indexOf(0) !== -1) {
            appboyBridge.logClick('1');
          }
          if("${btnAgain?.type}" === "attribute") {
            appboyBridge.getUser().setCustomUserAttribute("${btnAgain?.close_button}", new Date());
          }
          if("${btnAgain?.type}" === "event") {
            appboyBridge.logCustomEvent("${btnAgain?.close_button}");
          }
        } catch(error) {}
        appboyBridge.closeMessage();
      });
    }
  })
  `;

  return (
    <>
      <head>
        <meta charSet="UTF-8" />
        <meta
          name="viewport"
          content="width=device-width, initial-scale=1.0, maximum-scale=1.0, user-scalable=no"
        />
        <meta
          httpEquiv="Cache-Control"
          content="no-cache, no-store, must-revalidate"
        />
        <meta httpEquiv="Expires" content="0" />
        <meta httpEquiv="Pragma" content="no-cache" />

        {/* google font */}
        <link rel="preconnect" href="https://fonts.googleapis.com" />
        <link rel="preconnect" href="https://fonts.gstatic.com" />
        <link
          href="https://fonts.googleapis.com/css2?family=Roboto:wght@300;400;500;600;700&display=swap"
          rel="stylesheet"
        />
        <link
          href="https://fonts.googleapis.com/css2?family=Inter:wght@300;400;500;600;700&display=swap"
          rel="stylesheet"
        />
        <link
          href="https://fonts.googleapis.com/css2?family=Montserrat:wght@300;400;500;600;700&display=swap"
          rel="stylesheet"
        />
        <link
          href="https://fonts.googleapis.com/css2?family=Poppins:wght@300;400;500;600;700&display=swap"
          rel="stylesheet"
        />
        <link
          href="https://fonts.googleapis.com/css2?family=Archivo:wght@300;400;500;600;700&display=swap"
          rel="stylesheet"
        />
        <link
          rel="stylesheet"
          as="style"
          href="https://cdn.jsdelivr.net/gh/orioncactus/pretendard@v1.3.9/dist/web/static/pretendard.min.css"
        />
        <link
          rel="stylesheet"
          type="text/css"
          href="https://cdn.jsdelivr.net/npm/normalize.css@8.0.1/normalize.css"
        />
        <style dangerouslySetInnerHTML={{ __html: style }} />
        <script
          dangerouslySetInnerHTML={{
            __html: `               
            (function () {
              function adjustFontSize() {
                var actualSize = Math.round(parseFloat(window.getComputedStyle(document.documentElement).fontSize));
                if (actualSize !== 16) {              
                  var newFontSize = (16 * 16) / actualSize;
                  document.documentElement.style.fontSize = newFontSize + "px";                            
                }
              }                        
              adjustFontSize();
            })();                           
          `
          }}
        />
      </head>
      <body dangerouslySetInnerHTML={{ __html: html }} />
      <script dangerouslySetInnerHTML={{ __html: js }} />
    </>
  );
};

export default ChoiceOptionImageHTML;
